import "./NursingCaregiverInRishonLeZionWithinFiveHours.module.css";
import Header from "@/reusable_sections/Header";
import MassageHero from "./sections/MassageHero";
import ConsultingServices from "./sections/ConsultingServices";
import ServiceOfferingsGrid from "./sections/ServiceOfferingsGrid";
import FaqSection from "./sections/FaqSection";
import FinalCta from "./sections/FinalCta";
import Footer from "@/reusable_sections/Footer";
export default function NursingCaregiverInRishonLeZionWithinFiveHoursPage() {
  return <div>
      <Header />
      <MassageHero />
      <ConsultingServices />
      <ServiceOfferingsGrid />
      <FaqSection />
      <FinalCta />
      <Footer />
    </div>;
}